import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '@/lib/analytics';

/** Шлёт screen_view на каждую смену маршрута. Монтируется внутри RouterProvider. */
export function useScreenViewTracking(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    trackEvent('screen_view', { screen: pathname });
  }, [pathname]);
}
